import React from "react";
import styled from "styled-components";
import spriteImage from '../../assets/images/sprite.png';
import popup from "../../assets/images/water-quality-popup.png"
import {device} from "../../assets/styles/media";

const Container = styled.div``;
const Popup = styled.div`
    max-width: 650px;
    display: block;
    opacity: 1;
    padding: 45px 20px 50px 20px;
    border-radius: 10px;
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 1000;
    background-color: #fff;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    
    ${device.tablet}{
        max-width: 100vw;
        width: 60%;
        overflow: scroll;
        padding: 35px 10px 30px 10px;
    }
    ${device.mobile}{
        max-width: 100vw;
        width: 95%;
        overflow: scroll;
        padding: 35px 10px 25px 10px;
       
    }
    
`;
const ImgPopup = styled.div`
    display: block;
    opacity: 1;
    max-width: 800px;
    max-height: 800px;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    position: fixed;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    z-index: 1000;
    box-sizing: border-box;

    ${device.tablet}{
        max-width: 100vw;
        width: 60%;
        overflow: scroll;
        padding: 35px 10px 30px 10px;
    }
    ${device.mobile}{
        overflow: scroll;
    }
`;
const ScrollArea = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.15);
        border-radius: 10px;
    }
`;

const Img = styled.img`
    width: 100%;
`;
const Head = styled.div`
    text-align: center;
    margin-bottom: 35px;
    position: fixed;
    max-width: 100vw;
    width: 100%;
    padding: 35px 0;
    top: 0;
    left: 0;
`;
const Title = styled.strong`
    margin-bottom: 30px;
    font-size: 22px;
    font-weight: 600;
    ${device.mobile} {
        font-size: 18px;
        font-weight: 600;
    }
`;
const Close = styled.button`
    position: absolute;
    top: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    background-image: url(${spriteImage});
    background-size: 418px, 402px;
    background-position: -378px -84px;
    opacity: 0.5;
    
`;
const Content = styled.div`
    max-height: 650px;
    overflow-y: auto;
    overflow-x: hidden;
    max-width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    margin-top: 50px;

    &::-webkit-scrollbar {
        width: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.15);
        border-radius: 10px;
        background-clip: padding-box;
        border: 3px solid transparent;
    }

    &::-webkit-scrollbar-track {
        background-color: transparent;
    }
    
    ${device.mobile}{
        max-height: 400px;
    }
`;
const Bg = styled.div`
    display: block;
    opacity: 1;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
`;

const Modal = ({title, open, setOpenModal, content, width, img}) => {

    return (
        <Container>
            {img ? (
                <ImgPopup openModal={open} width={width}>
                    <Close onClick={() => setOpenModal(false)}/>
                    <ScrollArea>
                        <Img src={popup} />
                    </ScrollArea>
                </ImgPopup>
                )
                :
                (
                <Popup openModal={open} width={width}>
                    <Head>
                        <Close onClick={() => setOpenModal(false)}/>
                        <Title>{title}</Title>
                    </Head>
                    <Content>{content}</Content>
                </Popup>
            )
            }
            <Bg openModal={open}/>
        </Container>
    );
};

export default Modal;
